import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import {
    actions,
    fetchRedashLinkProxySuccess,
    fetchEmbeddedLinkSuccess
} from './duck';

import {
    getGatewayGraphQLEndpoint,
    getEmbeddedLinkEndpoint
} from './selectors';

/**
 * @export
 * @param {*} api
 * @param {{ type: String, payload: String[] }} action
 */
export function* fetchRedashLinkProxy(api, action) {
    const notificationId = 'fetchRedashLinkProxy';
    const { entityId, slug } = action.payload;
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'post',
                url: yield select(getGatewayGraphQLEndpoint),
                data: {
                    query: `query getProxiedRedashDashboard($entityId: Int!, $slug: String!) {
                        getProxiedRedashDashboard(entityId: $entityId, slug: $slug ) {
                            frameUrl
                        }
                    }`,
                    variables: {
                        entityId,
                        slug
                    },
                },
            }
        );

        yield put(fetchRedashLinkProxySuccess(result.data));
    } catch (err) {
        yield put(
            notify({
                id: notificationId,
                ...sagaError(err),
            })
        );
    }
}

/**
 * @export
 * @param {*} api
 * @param {{ type: String, payload: String[] }} action
 */
export function* fetchEmbeddedLink(api, action) {
    const notificationId = 'fetchEmbeddedLink';

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(getEmbeddedLinkEndpoint, action.payload)
            }
        );

        yield put(fetchEmbeddedLinkSuccess(result.data));
    } catch (err) {
        yield put(
            notify({
                id: notificationId,
                ...sagaError(err),
            })
        );
    }
}

export default function* channelSagas({ api }) {
    yield all([
        takeLatest(actions.FETCH_REDASH_LINK_PROXY, fetchRedashLinkProxy, api),
        takeLatest(actions.FETCH_EMBEDDED_LINK, fetchEmbeddedLink, api),
    ]);
}



// WEBPACK FOOTER //
// ./src/services/embeddedLinks/saga.js